<ng-container>
    {{ config?.value |booleanToFrench }}
</ng-container>